import sdk from '@incognia/web-sdk'
import { getConfig } from '@/tools/config'

let isInitialised = false
export const initIncognia = async () => {
  const { incogniaSdkKey } = getConfig()
  await sdk.init(incogniaSdkKey)
  isInitialised = true
}

export const setUserId = async (userId: number) => {
  if (!isInitialised) {
    await initIncognia()
  }
  await sdk.setAccountId(String(userId))
}

export const clearUserId = async () => {
  if (!isInitialised) {
    await initIncognia()
  }
  await sdk.clearAccountId()
}
